import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter} from 'react-router-dom';
import {createStore, applyMiddleware} from 'redux';
import rootReducer from './Redux/reducer';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import * as serviceWorker from './serviceWorker';

import App from './Components/App';
import './css/index.css';
import './Components/i18n';

const store = createStore(rootReducer, 
  window._REDUX_DEVTOOLS_EXTENSION_ && window.REDUX_DEVTOOLS_EXTENSION_(), 
  applyMiddleware(thunk));
  console.log('React app router base', process.env.REACT_APP_ROUTER_BASE)

ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      {/* Dev-Server Purpose */}
      <BrowserRouter basename='adviser'><App/></BrowserRouter>
      {/* For Local */}
	  {/* <BrowserRouter><App/></BrowserRouter> */}
    </Provider>
    </StrictMode>,
    document.getElementById('App')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
